import { forwardRef, type TextareaHTMLAttributes } from "react"

interface TextAreaFieldProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  maxLength?: number
  currentLength?: number
  hasError?: boolean
}

/**
 * Textarea with optional character count display.
 * Forwards ref for React Hook Form register compatibility.
 */
export const TextAreaField = forwardRef<HTMLTextAreaElement, TextAreaFieldProps>(
  ({ maxLength, currentLength = 0, hasError = false, className = "", rows = 3, ...props }, ref) => {
    const baseClasses =
      "w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 transition-colors resize-none"
    const stateClasses = hasError
      ? "border-red-300 focus:ring-red-500/20 focus:border-red-500"
      : "border-slate-200/50 focus:ring-emerald-500/20 focus:border-emerald-500"

    return (
      <div className="relative">
        <textarea
          ref={ref}
          rows={rows}
          maxLength={maxLength}
          className={`${baseClasses} ${stateClasses} ${className}`}
          {...props}
        />
        {maxLength && (
          <div className="absolute bottom-2 right-2 text-xs text-gray-400">
            {currentLength}/{maxLength}
          </div>
        )}
      </div>
    )
  }
)

TextAreaField.displayName = "TextAreaField"
